import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.368 4.776a7.8 7.8 0 0 0-1.719-2.488A8 8 0 0 0 11.109.615 8.1 8.1 0 0 0 8 0a8.1 8.1 0 0 0-3.108.613 8 8 0 0 0-2.541 1.673A7.8 7.8 0 0 0 .632 4.774 7.6 7.6 0 0 0 0 7.828c0 1.518.363 3.03 1.077 4.488.575 1.172 1.377 2.314 2.388 3.4 1.726 1.854 3.537 2.987 4.051 3.29a.95.95 0 0 0 .964 0c.514-.303 2.324-1.436 4.051-3.29 1.01-1.084 1.813-2.228 2.387-3.4C15.637 10.86 16 9.351 16 7.83a7.6 7.6 0 0 0-.632-3.054M8 17.488c-1.417-.9-6.452-4.469-6.452-9.658a6.16 6.16 0 0 1 1.884-4.436A6.5 6.5 0 0 1 8 1.548c1.727 0 3.348.656 4.568 1.848a6.15 6.15 0 0 1 1.884 4.434c0 5.19-5.035 8.757-6.452 9.658M8 4.215a3.785 3.785 0 1 0 0 7.57 3.785 3.785 0 0 0 0-7.57m1.703 5.488A2.4 2.4 0 0 1 8 10.41a2.4 2.4 0 0 1-1.703-.706A2.4 2.4 0 0 1 5.59 8a2.4 2.4 0 0 1 .706-1.703A2.4 2.4 0 0 1 8 5.59c.643 0 1.247.25 1.703.706s.706 1.06.706 1.703-.25 1.247-.706 1.703"
    }, null, -1)
  ])))
}
export default { render: render }